import { Box, Link as MUILink, styled } from '@mui/material'

export const TestimonialContainer = styled(Box)(({ theme }) => ({
  color: theme.palette.surface[100],
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('sm')]: {
    alignItems: 'flex-start',
    flexDirection: 'row',
  },
  [theme.breakpoints.up('lg')]: {
    alignItems: 'center',
  },
}))

export const TestimonialContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  alignItems: 'flex-start',
  [theme.breakpoints.up('lg')]: {
    paddingRight: theme.spacing(8),
  },
}))

export const TestimonialText = styled(Box)(({ theme }) => ({
  ...theme.typography.h6,
}))

export const ClientInfo = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}))

export const Link = styled(MUILink)(({ theme }) => ({
  color: theme.palette.surface['300'],
  cursor: 'pointer',
  lineHeight: 0,
}))
